import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Composer } from '../jobs/composer.tsx';
import { authClient } from '../lib/auth.ts';

/**
 * `/static-ad` — the composer, ordering a still.
 *
 * The screen itself is `jobs/composer.tsx`; this file is the address, the
 * guard and the kind. `/video-ad` is the same three things with a different
 * kind, which is what stops the two from becoming two screens that drift.
 */
function StaticAd() {
  const { entry, productId, brandId, sample } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <Composer
      brandId={brandId}
      entry={entry}
      home={{ to: '/image-ads', label: 'Image ads' }}
      kind="static_ad"
      onProduct={(id) => void navigate({ search: { entry, brandId, sample, productId: id } })}
      productId={productId}
      sampleKey={sample}
    />
  );
}

export const Route = createFileRoute('/static-ad')({
  validateSearch: z.object({
    entry: z.enum(['blank', 'clone']).default('blank'),
    productId: z.uuid().optional(),
    brandId: z.uuid().optional(),
    /**
     * A key of `image_templates`. Not validated as an enum here for the reason
     * every other dictionary key is not: the catalog grows by migration, and a
     * key this build has never heard of is refused by the API, which is where
     * the dictionary lives (`docs/CATALOGS.md`).
     */
    sample: z.string().trim().min(1).optional(),
  }),
  beforeLoad: async ({ location }) => {
    const { data } = await authClient.getSession();
    if (!data) throw redirect({ to: '/login', search: { redirectTo: location.href } });
  },
  component: StaticAd,
});
